module.exports = {
    locale_name: 'Magyar',
    locale_shorthand: ['hu', 'magyar'],
    // Translations:
    justifyCenter: 'Középre Igazított',
    justifyLeft: 'Balra Igazított',
    justifyRight: 'Jobbra Igazított',
    bold: 'Félkövér',
    code: 'Kód',
    headings: 'Bekezdéscímek (h1-h6)',
    link: 'Hivatkozás',
    image: 'Kép beszúrása',
    italic: 'Dőlt',
    orderedList: 'Rendezett Lista (1, 2, 3, ...)',
    unorderedList: 'Felsorolás',
    removeFormat: 'Formázás törlése.\nEltávolítja a bekezdéscímeket, félkövér, dőlt, stb. formázásokat.',
    separator: null,
    table: 'Táblázat beszúrása',
    underline: 'Aláhúzott'
}